import { useState, createContext, useCallback, useContext, useMemo } from 'react';
import moment from 'moment';
import Toast from '../Toast/Toast';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { ToastProviderProps, ToastState, ToastType } from './types';
import { ToastWrapper } from '../Toast/styles';

export const initialToastState: ToastState = {
  generateToast: () => null,
};

export const ToastContext = createContext(initialToastState);

const ToastProvider = ({ children, isMobile }: ToastProviderProps) => {
  const [toasts, setToasts] = useState<any[]>([]);
  const { isMobile: mobileTheme } = useContext(ThemeContext);
  const useMobileVersion = useMemo(() => isMobile ?? mobileTheme, [isMobile, mobileTheme]);
  const deleteToast = useCallback(() => {
    const toastListItem = toasts.filter((e) => moment().diff(moment(e.id), 'seconds') < 5);
    setToasts(toastListItem);
  }, [toasts, setToasts]);
  const generateToast = useCallback((toast: ToastType) => {
    setToasts((current) => {
      let addedToast = current;
      const toastToAdd = { ...toast, id: moment().toISOString() };
      if (current && current.length >= 5) {
        addedToast = current.slice(1);
      }
      return addedToast.concat(toastToAdd);
    });
  }, []);

  return (
    <ToastContext.Provider value={{ generateToast }}>
      {children}
      <ToastWrapper isMobile={useMobileVersion}>
        {toasts &&
          toasts.map((toast, index) => (
            <Toast
              key={toast.id}
              index={index}
              toast={toast}
              toasts={toasts}
              deleteToast={deleteToast}
            />
          ))}
      </ToastWrapper>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
